<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  stepsCount: number;
  isNext: boolean;
  currentStep: number;
  title: string;
}>();

const emit = defineEmits(['nextStep', 'goBack', 'startOver', 'submit']);

const submit = () => {
  emit('submit');
};
const nextStep = () => {
  emit('nextStep');
};
const goBack = () => {
  emit('goBack');
};

const startOver = () => {
  emit('startOver');
};

const progressWidth = computed(() => {
  return `${((props.currentStep + 1) / props.stepsCount) * 100}%`;
});
</script>

<template>
  <form
    @submit.prevent="submit"
    class="steps-layout"
    :class="{ 'last-step': props.currentStep > stepsCount - 1 }"
  >
    <div class="steps-layout__progress">
      <div class="steps-layout__progress__title text-m">{{ title }}</div>
      <div class="steps-layout__progress__bar"></div>
    </div>
    <div class="steps-layout__content">
      <div class="steps-layout__content__header">
        <button
          v-show="props.currentStep > 0"
          class="btn btn-sm steps-layout__content__header__btn"
          type="button"
          @click="goBack"
        >
          Back
        </button>
        <button
          class="btn btn-sm steps-layout__content__header__btn start-over"
          type="button"
          @click="startOver"
        >
          <span class="material-icons-outlined">restart_alt</span> Start over
        </button>
      </div>
      <div class="steps-layout__content__form">
        <slot />
      </div>
      <div
        v-if="isNext"
        class="w-100 d-flex"
      >
        <button
          class="btn wide red steps-layout__content__next"
          v-if="props.currentStep === props.stepsCount - 1"
          type="submit"
        >
          Submit
        </button>
        <button
          class="btn wide red steps-layout__content__next"
          v-else-if="props.currentStep < props.stepsCount"
          type="button"
          @click="nextStep()"
        >
          Next
        </button>
      </div>
    </div>
  </form>
</template>

<style lang="scss">
.steps-layout__progress__bar {
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: var(--dark-blue);
    width: v-bind(progressWidth);
    transition: width 0.3s ease-in-out;
  }
}
</style>
